export const cityField = `
city{
  name
},
district{
  name
}`;
